export const EACG = "EACG";
export const INSTITUTIONAL_SITE_LOGIN = "Institutional Site Login";
